import { useState, useEffect } from 'react';
import { Button } from './components/Button';
import './App.css';


function App() {

  const [btnPressed, setBtnPressed] = useState('');  
  const [dataFetch, setDataFetch] = useState([]); 

  const handleClick = (e) => {  
    setBtnPressed(e.target.id);
  }

  useEffect( ()=> {
    fetch(`https://jsonplaceholder.typicode.com/${btnPressed}`)
    .then((response) => response.json())
    .then((data) => setDataFetch(data));
    console.log(dataFetch);
  }, [btnPressed] )

 
 
 

  return (
    <div className="container">
      <h1>Post Api React Demo</h1>
      <div>
            <Button id="posts" text="Posts" btnClass="btn red" onClickEve={handleClick}/>
            <Button id="users" text="Users" btnClass="btn blue" onClickEve={handleClick} />
            <Button id="comments" text="Comments" btnClass="btn green" onClickEve={handleClick} />
            
      </div>

      {btnPressed ? (<p className='title'>Viewing {btnPressed}</p>) : (<p>Choose from above</p>)}

      {dataFetch && dataFetch.map((d) => (
        <div key={d.id} className='card'>
          {d.title 
          ? 
          (<><p className='title'>{d.title}</p>
          <p className='body'>{d.body}</p></>) 
          : 
          (<p>{d.name}</p>)
          }
        </div>
      ))} 

    </div>
  );
}

export default App;
